/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Current_PeriodInputs */



/**
* | output |
* | --- |
* | "Current Period" |
*
* @param {Usage_Current_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_current_period = /** @type {((inputs?: Usage_Current_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Current_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Période actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Periode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Periodo corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущий период")
	if (locale === "es") return /** @type {LocalizedString} */ ("Periodo actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("当期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Período atual")
	return /** @type {LocalizedString} */ ("Current Period")
});